import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  Icon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import DescriptiveRow from "../components/DescriptiveRow.jsx";
import FormCheckbox from "components/Wrappers/materialUIWrappers/components/FormCheckbox.jsx";
import FormDropdown from "components/Wrappers/materialUIWrappers/components/FormDropDown";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import { RemoveField } from "helpers/ReduxHelpers";
import _ from "lodash";
import React from "react";
import { change, Field } from "redux-form";
import store from "store";
import CustomCardHeading from "../components/CustomCardHeading.jsx";
import { banks } from "./objects/banks";
import { otherLiabilityItems } from "./objects/otherLiabilityItems";
import NumberInput from "components/Wrappers/materialUIWrappers/components/NumberInput";

const colwidth = value => {
  return {
    width: value,
    minWidth: value,
    maxWidth: value
  };
};

const required = value => (value ? undefined : "Required");

class OtherLiability extends React.Component {
  componentDidMount() {
    this.props.scrollMeBar();
  }
  
  add = name => {
    let liabilities = _.get(
      store.getState().form,
      "newfna.values.liabilities." + name,
      {}
    );

    let id = 0;
    if (Object.keys(liabilities).length > 0) {
      let max = Math.max.apply(
        Math,
        Object.keys(liabilities).map(function(b) {
          return parseInt(b, 10);
        })
      );
      id = max + 1;
    }

    store.dispatch(
      change("newfna", "liabilities." + name + "." + id, {
        settle_disability: false
      })
    );

    this.props.RemoveIgnore(`liabilities.${name}`);

    this.forceUpdate();
  };

  remove = (name, id) => {
    const fieldParent = `liabilities.${name}`;
    const ignore = RemoveField("newfna", `${fieldParent}.${id}`, fieldParent);
    if (ignore) {
      this.props.AddIgnore(fieldParent);
    }
    this.forceUpdate();
  };

  render() {
    let { checkValidation } = this.props;

    let liabilities = _.get(
      store.getState().form,
      "newfna.values.liabilities",
      {}
    );

    return (
      <div className="contentWithStepper">
        <Card>
          <CardContent>
            <CustomCardHeading
              subheading={"Financial Needs Analysis"}
              caption={"Client Name"}
              headline={"Other Liability"}
            />

            <Grid container spacing={24} className="customTableAutoGrid">
              <Table className="customTable1">
                <TableHead className="fixedHead">
                  <TableRow>
                    <TableCell style={colwidth("15em")}>Liability</TableCell>
                    <TableCell style={colwidth("10.5em")}>Amount</TableCell>
                    <TableCell style={colwidth("12em")}>To who?</TableCell>
                    <TableCell style={colwidth("10.5em")}>
                      Settle at disability?
                    </TableCell>
                    <TableCell style={colwidth("12em")}>
                      Who is liable?
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {otherLiabilityItems.map(l => {
                    let fieldItems =
                      liabilities &&
                      liabilities[l.name] &&
                      Object.keys(liabilities[l.name]).length > 0
                        ? liabilities[l.name]
                        : null;

                    return (
                      <React.Fragment key={l.name}>
                        <DescriptiveRow
                          description={l.displayName}
                          add={() => this.add(l.name)}
                          count={fieldItems ? fieldItems.length : 0}
                          extraCells={4}
                        />

                        {!fieldItems
                          ? null
                          : Object.keys(fieldItems).map((id, i) => {
                              return (
                                <TableRow key={l.name + id}>
                                  <TableCell
                                    style={
                                      i !== fieldItems.length - 1
                                        ? { border: "0px" }
                                        : {}
                                    }
                                    padding="none"
                                    className="cellPaddingSmall"
                                  >
                                    <Grid container>
                                      <Grid item xs={2} sm={2} md={2}>
                                        <Button
                                          variant="fab"
                                          mini
                                          className="minifab"
                                          style={{
                                            top: "18px",
                                            backgroundColor: "#ffae4a"
                                          }}
                                          onClick={() =>
                                            this.remove(l.name, id)
                                          }
                                        >
                                          <Icon>remove</Icon>
                                        </Button>
                                      </Grid>
                                      <Grid item xs={10} sm={10} md={10}>
                                        <FormControl fullWidth>
                                          <Field
                                            component={FormInput}
                                            isrequired={true}
                                            validate={[required]}
                                            checkValidation={checkValidation}
                                            name={
                                              "liabilities." +
                                              l.name +
                                              "." +
                                              id +
                                              ".description"
                                            }
                                            label="Description"
                                          />
                                        </FormControl>
                                      </Grid>
                                    </Grid>
                                  </TableCell>
                                  <TableCell
                                    padding="none"
                                    className="cellPaddingSmall"
                                  >
                                    <FormControl fullWidth>
                                      <Field
                                        component={NumberInput}
                                        prefix="R"
                                        seperator=" "
                                        isrequired={true}
                                        validate={[required]}
                                        checkValidation={checkValidation}
                                        name={
                                          "liabilities." +
                                          l.name +
                                          "." +
                                          id +
                                          ".amount"
                                        }
                                        label="Amount"
                                      />
                                    </FormControl>
                                  </TableCell>
                                  <TableCell
                                    padding="none"
                                    className="cellPaddingSmall"
                                  >
                                    <FormControl fullWidth>
                                      <Field
                                        component={FormDropdown}
                                        checkValidation={
                                          this.props.checkValidation
                                        }
                                        label="To Who?"
                                        name={
                                          "liabilities." +
                                          l.name +
                                          "." +
                                          id +
                                          ".towho"
                                        }
                                        options={banks}
                                      />
                                    </FormControl>
                                  </TableCell>
                                  <TableCell
                                    padding="none"
                                    className="cellPaddingSmall"
                                  >
                                    <FormControl fullWidth>
                                      <Field
                                        component={FormCheckbox}
                                        name={
                                          "liabilities." +
                                          l.name +
                                          "." +
                                          id +
                                          ".settle_disability"
                                        }
                                      />
                                    </FormControl>
                                  </TableCell>
                                  <TableCell>
                                    <FormControl fullWidth>
                                      <Field
                                        component={FormDropdown}
                                        checkValidation={
                                          this.props.checkValidation
                                        }
                                        label="Who is liable?"
                                        name={
                                          "liabilities." +
                                          l.name +
                                          "." +
                                          id +
                                          ".person_liable"
                                        }
                                        options={[
                                          {
                                            value: "validationError",
                                            displayValue: "Please select"
                                          },
                                          {
                                            value: "client",
                                            displayValue: "Client"
                                          },
                                          {
                                            value: "spouse",
                                            displayValue: "Spouse"
                                          }
                                        ]}
                                      />
                                    </FormControl>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                      </React.Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            </Grid>
          </CardContent>
        </Card>
      </div>
    );
  }
}

export default OtherLiability;



// WEBPACK FOOTER //
// ./src/views/Fna/steps/OtherLiability.jsx